module.exports = __webpack_public_path__ + "static/media/dodgem(12).264fcd42.PNG";